export function truncateText(value, length) {
  return value.length > length
    ? `${value.substr(0, length)}...`
    : value
}
